import { readableColor } from 'polished';
import { css, styled } from 'styled-components';

import { InternalButtonProps } from '.';
import theme from 'styles/theme';

export type WrapperProps = {
  hasIcon: boolean;
  textColor?: string;
} & Pick<InternalButtonProps, 'size' | 'variant' | 'background'>;

const wrapperModifiers = {
  outline: (background?: string) => css`
    border: 1px solid ${background || theme.COLORS.PRIMARY};
    background: transparent;
    color: ${background || theme.COLORS.PRIMARY};
  `,
  minimal: (background?: string) => css`
    border: none;
    background: transparent;
    color: ${theme.COLORS.PRIMARY};
    span {
      position: relative;
      text-decoration: none;
      color: ${theme.COLORS.PRIMARY};

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        background-color: ${theme.COLORS.PRIMARY};
        transition: width 0.3s ease;
      }

      &::before {
        left: 50%;
        transform: translateX(-50%);
      }

      &::after {
        right: 50%;
        transform: translateX(50%);
      }

      &:hover::before,
      &:hover::after {
        width: 100%;
      }
    }
  `,
  primary: (background?: string) => css`
    background: ${background || theme.COLORS.PRIMARY};
  `,

  withBackground: (background: string) => {
    return css`
      border-color: ${background};
      background: ${background};
      color: ${readableColor(background)};
    `;
  },
};

export const Wrapper = styled.button<WrapperProps>`
  ${({ textColor, variant, background }) => css`
    all: unset;
    font-size: 0.85rem;
    height: 1.25rem;
    border-radius: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    font-family: 'Roboto', sans-serif;
    padding: 0.2rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    cursor: pointer;
    width: fit-content;
    color: ${textColor || theme.COLORS.BACKGROUND_PRIMARY};

    span {
      display: flex;
      align-items: center;
      width: max-content;
    }

    svg {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    ${!!variant && wrapperModifiers[variant](background)};

    &:disabled {
      cursor: not-allowed;
      opacity: 0.7;
      border-color: ${background};
      color: ${textColor || theme.COLORS.BACKGROUND_PRIMARY};

      svg {
        color: ${textColor || theme.COLORS.BACKGROUND_PRIMARY};
      }

      &:hover {
        border-color: ${background};
        opacity: 0.7;
      }
    }
  `}
`;
